module.exports = __webpack_public_path__ + "img/7-consumers-and-stylists-tape.png";